/* MC Mesyd v3: email-first on ALL pool checkouts. Keep cart key. Shop Pay stays as button. */
(function(){
  if (window.__mcSkipShopPayHook) return;
  window.__mcSkipShopPayHook = true;
  var MAP = {
    'store.messyd.com': 'store.messyd.com',
    'fzxs11-yv.myshopify.com': 'store.messyd.com',
    'checkout.messyd.com': 'checkout.messyd.com',
    'mdhgq3-3x.myshopify.com': 'checkout.messyd.com',
    'secure.messyd.com': 'secure.messyd.com',
    'eyz4pi-rn.myshopify.com': 'secure.messyd.com',
    'secure.mesyds.com': 'secure.mesyds.com',
    'v9hhhr-n1.myshopify.com': 'secure.mesyds.com',
    '7qiamp-i8.myshopify.com': '7qiamp-i8.myshopify.com'
  };
  function rewrite(url){
    if (!url || typeof url !== 'string') return url;
    try {
      var u = new URL(url, location.href);
      var h = u.hostname.toLowerCase();
      var dest = MAP[h];
      if (!dest) return url;
      u.hostname = dest;
      u.searchParams.set('skip_shop_pay', 'true');
      return u.toString();
    } catch (e) { return url; }
  }
  function walk(o){
    if (!o || typeof o !== 'object') return;
    if (typeof o.checkoutUrl === 'string') o.checkoutUrl = rewrite(o.checkoutUrl);
    if (typeof o.checkout_url === 'string') o.checkout_url = rewrite(o.checkout_url);
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) walk(o[k]);
  }
  try {
    var desc = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
    if (desc && desc.set && desc.get) {
      Object.defineProperty(Location.prototype, 'href', {
        configurable: true, enumerable: true,
        get: function(){ return desc.get.call(this); },
        set: function(v){ desc.set.call(this, rewrite(v)); }
      });
    }
  } catch (e) {}
  try {
    var asg = Location.prototype.assign, rep = Location.prototype.replace;
    Location.prototype.assign = function(v){ return asg.call(this, rewrite(String(v))); };
    Location.prototype.replace = function(v){ return rep.call(this, rewrite(String(v))); };
  } catch (e) {}
  var ofetch = window.fetch;
  if (typeof ofetch === 'function') {
    window.fetch = function(){
      return ofetch.apply(this, arguments).then(function(res){
        var ct = (res.headers && res.headers.get('content-type')) || '';
        if (ct.indexOf('json') === -1) return res;
        return res.clone().json().then(function(j){
          walk(j);
          return new Response(JSON.stringify(j), {
            status: res.status,
            statusText: res.statusText,
            headers: { 'content-type': 'application/json' }
          });
        }).catch(function(){ return res; });
      });
    };
  }
})();
